import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sendSearchStatistic } from '../../../../appSlice';
import {
  fetchHotelById,
  fetchHotelsByName,
} from '../../../search/searchSlice';
import { selectActiveDestinations } from '../../selectors';

export default function useGetSearchResults(debounceSearchValue, tempDestinationIds) {
  const dispatch = useDispatch();
  const search = useSelector(state => state.userSearch);
  const destinations = useSelector(selectActiveDestinations);
  const destinationIds = tempDestinationIds || destinations.map(destination => destination.id);
  const { hotels } = search;

  useEffect(() => {
    if (debounceSearchValue.length < 3) return;

    const selectedHotelIndex = hotels.findIndex(({ hotelName }) => hotelName === debounceSearchValue);
    if (selectedHotelIndex === -1) {
      dispatch(fetchHotelsByName({ name: debounceSearchValue, destinationIds }));
    } else {
      dispatch(fetchHotelById({ id: hotels[selectedHotelIndex].hotelId, destinationIds }));
    }

    dispatch(sendSearchStatistic({
      action: 'ac',
      value: debounceSearchValue,
      type: 'hotel',
    }));
  }, [dispatch, debounceSearchValue]);

  return {
    hotels,
  };
}
